// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    // "aws_cognito_identity_pool_id": "ap-southeast-2:07c8bf6e-b1b6-4bfd-ba86-0318ba06d8a9",
    "aws_cognito_identity_pool_id": process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    "aws_cognito_region": "ap-southeast-2",
    // "aws_user_pools_id": "ap-southeast-2_Y4lfhpvCE",
    "aws_user_pools_id": process.env.REACT_APP_AWS_USER_POOLS_ID,
    // "aws_user_pools_web_client_id": "17atrsn4sgm8dkjmteu7cm1ffd",
    "aws_user_pools_web_client_id": process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
    "oauth": {
        "domain": process.env.REACT_APP_OAUTH_DOMAIN,
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": process.env.REACT_APP_OAUTH_REDIRECT_SIGNIN,
        "redirectSignOut": process.env.REACT_APP_OAUTH_REDIRECT_SIGNOUT,
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};


export default awsmobile;
